import { render, staticRenderFns } from "./GridSquare.vue?vue&type=template&id=3c4e9ade&"
import script from "./GridSquare.vue?vue&type=script&lang=js&"
export * from "./GridSquare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports